import { render, staticRenderFns } from "./VoteResult.vue?vue&type=template&id=6a9a3a9a"
import script from "./VoteResult.vue?vue&type=script&lang=js"
export * from "./VoteResult.vue?vue&type=script&lang=js"
import style0 from "./VoteResult.vue?vue&type=style&index=0&id=6a9a3a9a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports